module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/10Qizl4/tc-custom/9781611525779.jpg?1723406707954",
      "alt": "This image is the cover for the book The Horse Who Went to Church"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Horse Who Went to Church\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A rider faces a difficult situation, as she must attend church then almost immediately get her horse to a dressage show. There’s very little time after Mass to go home, hitch up the trailer, load up the animal, and be punctual for her first class."), _c('br'), _c('br'), _vm._v("To make life easier, she decides to haul her gelding to church. Firecross is munching hay in his trailer in the parking lot as she sits in her pew waiting for Mass to begin."), _c('br'), _c('br'), _vm._v("But the service never starts. Hooves suddenly clatter up the center aisle: they belong to Firecross, and pandemonium ensues."), _c('br'), _c('br'), _vm._v("Will the horse trample the parishioners? What will Father Frank’s reaction be? Will he throw the owner out of his church with her horse? And, most importantly, will they still be able to make it to the dressage show in time to compete?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Hilary Walker\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0